import React from "react";
import { Star, Award, Info, MessageSquareDashed } from "lucide-react";

export function Stars({ value, size = "h-4 w-4" }) {
  return <span className="inline-flex">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-[#F59E0B] text-[#F59E0B]" : "text-[#475569]"}`} />)}</span>;
}

const Stat = ({ label, value, testid }) => (
  <div className="rounded-xl border border-[#2A3655] bg-[#0B1020] p-3">
    <p className="text-[11px] uppercase tracking-wide text-[#64748B]">{label}</p>
    <p className="mt-1 font-display text-lg font-semibold text-[#F8FAFC]" data-testid={testid}>{value}</p>
  </div>
);

export function ReputationSummary({ p }) {
  const hasReviews = p.feedback_count > 0;
  return (
    <section className="mt-6 rounded-2xl border border-[#2A3655] bg-[#141B2D] p-5" data-testid="reputation-summary">
      <h2 className="font-display text-lg font-semibold text-[#F8FAFC]">Reputazione</h2>
      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
        <div className="col-span-2 rounded-xl border border-[#2A3655] bg-[#0B1020] p-3 sm:col-span-1">
          <p className="text-[11px] uppercase tracking-wide text-[#64748B]">Media valutazioni</p>
          {hasReviews ? <p className="mt-1 flex items-center gap-2 font-display text-lg font-semibold text-[#F8FAFC]" data-testid="rep-average">{p.feedback_average.toFixed(1)} <Stars value={p.feedback_average} /></p>
            : <p className="mt-1 flex items-center gap-1 text-sm text-[#94A3B8]" data-testid="rep-no-reviews"><MessageSquareDashed className="h-4 w-4" />Nessuna recensione ancora</p>}
        </div>
        <Stat label="Recensioni" value={p.feedback_count} testid="rep-count" />
        <Stat label="Scambi completati" value={p.completed_trades} testid="rep-completed" />
        <Stat label="Iscritto dal" value={new Date(p.created_at).toLocaleDateString("it-IT")} testid="rep-member-since" />
      </div>
      {p.badges?.length > 0 && (
        <div className="mt-4">
          <div className="flex flex-wrap gap-2">{p.badges.map((b) => (
            <span key={b.code} data-testid={`badge-${b.code}`} className="inline-flex items-center gap-1 rounded-full border border-[#2DD4BF]/40 bg-[#2DD4BF]/10 px-3 py-1 text-xs font-semibold text-[#2DD4BF]"><Award className="h-3.5 w-3.5" />{b.label}</span>
          ))}</div>
          <p className="mt-2 flex items-start gap-1 text-[11px] text-[#64748B]"><Info className="mt-0.5 h-3 w-3 shrink-0" />I badge indicano l'esperienza sulla piattaforma (scambi completati e confermati), non garantiscono che un utente sia sicuro o affidabile.</p>
        </div>
      )}
    </section>
  );
}
